<template>
<div>
  <transition name="fade">
    <div v-if="!dataLoaded" class="rainbow-spinner">
      <md-progress-spinner class="spinner" :md-diameter="40" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
    </div>
  </transition>
  <transition name="fade">
    <div class="md-layout">
      <div v-if="products.length" 
      class="md-layout-item" style="position:fixed;bottom:0;right:0;width:auto;">
        <md-card>
          <md-card-content>
            <md-button
              @click="save()"
              class="md-success md-xs md-round md-just-icon pull-right" :disabled="!canSave">
              <md-icon>check</md-icon>
            </md-button>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-xsmall-size-80 md-small-size-80 md-medium-size-70 md-large-size-65 md-xlarge-size-50 mx-auto">
      <draggable
          tag="div"
          v-model="products"
          v-bind="dragOptions"
          @start="startDragging"
          @end="endDragging"
          @change="changeOrder"
        >
          <transition-group type="transition" :name="!isDragging ? 'flip-list' : null">
            <md-card v-for="(product, index) in products" :key="product.Id" style="margin:5px 0; cursor:move;">
              <md-card-content class="md-card-content p-0">
                <div class="md-layout">
                  <div>
                    <div class="image-container">
                      <img :src="product.CoverPhoto.Thumbnail" />
                    </div>
                  </div>
                  <div class="md-layout-item md-size-80 hlh-50">
                    {{ product.Name }}
                  </div>
                  <div class="md-layout-item">
                    <h6 class="m-0 p-0 hlh-50">{{index + 1}}</h6>
                  </div>
                </div>
              </md-card-content>
            </md-card>
          </transition-group>
        </draggable>
      </div>
    </div>
  </transition>
</div>
</template>

<style>
.m-0 {
  margin: 0;
}
.p-0 {
  padding: 0 !important;
}
.hlh-50 {
  height: 50px;
  line-height: 50px;
}
.hlh-25 {
  height: 25px;
  line-height: 25px;
}
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.image-container {
  width: 50px;
  height: 50px;
  margin: 0;
}
</style>

<script>
import axios from "axios";
import draggable from "vuedraggable";

import {
  StatsCard,
  AnimatedNumber
} from "@/components";

export default {
  components: {
    draggable
  },
  data() {
    return {
      isDragging: false,
      dataLoaded: false,
      products: [],
      canSave: false,
      filters: {
        sortBy: "arranged",
        sortOrder: "asc",
        perPage: 1000,
        currentPage: 1,
        status: "all"
      }
    };
  },
  mounted() {
    axios
        .get("api/Product", {
          params: this.filters
        })
        .then(response => {
          this.products = response.data;
          this.dataLoaded = true;
        });
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      }
    }
  },
  methods: {
    startDragging () {
      this.isDragging = true
    },
    endDragging () {
      this.isDragging = false
    },
    changeOrder (item) {
      this.canSave = true
    },
    save () {
      let index = 1;
      let payload = this.products.map(p => {
        return {
          ProductId: p.Id,
          Index: index++
        }
      })

      console.log(payload)
      axios.put('api/Product/Arrangement', payload).then(() => {
        this.$notify({
          message: 'Products successfully rearranged',
          icon: "check_circle_outline",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success"
        });
      })
    } 
  }
};
</script>
